import { useParams } from 'react-router';

export const useBankAccountId = () => {
  const { id } = useParams<{ id: string }>();

  return id;
};
